<template>
  <div class="top-area-container">
    <div class="item" v-for="(item,index) in topData" :key="index">
      <div class="top">{{ $t('pc_community_top') }}</div>
      <div class="type">{{ +item.type ===1 ? $t('pc_community_note') :  +item.type === 2 ? $t('pc_community_article') : $t('pc_community_album')}}</div>
      <div class="title" @click="handleJump(item.id, item.boardType, item.boardId)">{{ item.title }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { TopContent } from '@/api/Models/CommunityHomeData'
import { useRouter } from 'vue-router'
const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)

defineProps<{
  topData: TopContent[]
}>()

const router = useRouter()
const handleJump = (id:string, boardType: number, boardId: string) => {
  if (+boardType === 1) {
    router.push({ path: '/comDetailLevel', query: { id } })
  } else {
    router.push({
      path: '/rollVideo',
      query: {
        sortType: 0,
        id,
        boardId
      }
    })
  }
}

</script>

<style lang="less" scoped>
.top-area-container {
  width: 100%;
  margin-top: 14px;
  padding: 12px 12px 3px 12px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 16px;
    margin-bottom: 9px;
    .top{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 4px;
      background: v-bind(themeColorWithAlpha);
      border-radius: 4px;
      color: v-bind(themeColor);
      font-size: 10px;
      font-weight: bold;
      margin-right: 4px;
    }
    .type{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 4px;
      background: #ffffff;
      border: 0.5px solid #999999;
      border-radius: 4px;
      font-size: 10px;
      color: #61666d;
      margin-right: 8px;
    }
    .title{
      flex: 1;
      font-size: 12px;
      color: #61666d;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }

  }
}
</style>
